var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqestVoiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.75002H11L9.15 7.65002L9.86667 6.93335L12 9.36669V12.6667C12 12.9334 11.9 13.1667 11.7 13.3667C11.5 13.5667 11.2667 13.6667 11 13.6667H1C0.733333 13.6667 0.5 13.5667 0.3 13.3667C0.1 13.1667 0 12.9334 0 12.6667V9.36669L2.25 6.88336L2.96667 7.60002L1 9.75002ZM10.3333 5.05002L6.8 8.58335C6.61111 8.77224 6.37778 8.87224 6.1 8.88336C5.82222 8.89447 5.57778 8.79447 5.36667 8.58335L2.71667 5.93335C2.50556 5.72224 2.41111 5.48613 2.43333 5.22502C2.45556 4.96391 2.56667 4.73336 2.76667 4.53336L6.3 1.00002C6.48889 0.811133 6.72222 0.713911 7 0.708355C7.27778 0.7028 7.51667 0.800022 7.71667 1.00002L10.3667 3.65002C10.5556 3.83891 10.6528 4.06391 10.6583 4.32502C10.6639 4.58613 10.5556 4.8278 10.3333 5.05002ZM9.51667 4.30002L7.01667 1.80002L3.55 5.26669L6.05 7.76669L9.51667 4.30002ZM1 12.6667H11V10.75H1V12.6667ZM1 12.6667V10.75V12.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqestVoiting);
export default __webpack_public_path__ + "static/media/ReqestVoiting.8b35976317e4b5788939c570760361aa.svg";
export { ForwardRef as ReactComponent };